/**
 * The shared "breathing" pulse used across the boost surfaces (footer status,
 * authorization handshake, live rail dots). The keyframe itself lives in
 * `src/index.css` behind the global `prefers-reduced-motion` guard.
 */
export const BREATHE_ANIMATION = 'boost-footer-breathe 2.4s ease-in-out infinite';
